import { render, staticRenderFns } from "./CompaniesTable.vue?vue&type=template&id=5db4e951&"
import script from "./CompaniesTable.vue?vue&type=script&lang=ts&"
export * from "./CompaniesTable.vue?vue&type=script&lang=ts&"
import style0 from "./CompaniesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports